import React, { useState } from "react";
import Header from "../../layout/Header";
import { useNavigate } from "react-router-dom";
 
import LoginBannerhi from "../../../assets/images/HindiBanner.png";
import LoginBannermr from "../../../assets/images/MarathiBanner.png";
import LoginBannerka from "../../../assets/images/KannadaBanner.png";
import LoginBannerte from "../../../assets/images/TeluguBanner.png";
import LoginBannerpb from "../../../assets/images/PunjabiBanner.png";
import LoginBannergu from "../../../assets/images/GujaratiBanner.jpg"; 
import LoginBannerta from "../../../assets/images/tamilBanner.png";
import LoginBanneren from "../../../assets/images/EnglishBanner.jpg";
import LoginBannerba from "../../../assets/images/BanglaBanner.png";
import LoginBannerod from "../../../assets/images/OdiyaBanner.png";

import { Loader } from "../../loader";
import RewardImage from "../../../assets/images/Rewards.png";
import ScanMoreImg from "../../../assets/images/Scanmore.png";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { claimStatus, rewardMoney } from "../../auth/redux/store";
import ConditionImg from '../../../assets/images/Termsconditions.png';
import ProgramImg from '../../../assets/images/programDetails.png'
import { useParams } from "react-router-dom";
import ReactGA from 'react-ga4';
export const Home = () => {
  const { t, i18n } = useTranslation();
  const { lang } = useParams(); 
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  dispatch(claimStatus(false));
  dispatch(rewardMoney(0));

    
  let bannerImageSrc;
  if (lang === 'hi') {
    bannerImageSrc = LoginBannerhi; 
  } else if (lang === 'mr') {
    bannerImageSrc = LoginBannermr; 
  } else if(lang === 'kn'){
    bannerImageSrc = LoginBannerka; 
  }else if (lang === 'te') {
    bannerImageSrc = LoginBannerte;
  }else if (lang === 'pa') {
    bannerImageSrc = LoginBannerpb;
  }else if (lang === 'gu') {
    bannerImageSrc = LoginBannergu;
  }else if (lang === 'ta') {
    bannerImageSrc = LoginBannerta;
  }else if (lang === 'en') {
    bannerImageSrc = LoginBanneren;
  }else if (lang === 'bn') {
    bannerImageSrc = LoginBannerba;
  }else if (lang === 'or') {
    bannerImageSrc = LoginBannerod;
  }
  else { 
    bannerImageSrc = LoginBannerhi; 
  }

  return (
    <>
      <Header />
     <div className="main px-2 mt-3">
            <div className="container p-0">
              {loading && <Loader />}
              <div className="card px-0 border-0">
                <img
                  src={bannerImageSrc}
                  className="img-fluid w-100 shadow"
                  alt="banner"
                />
                
            <div className="card-body pb-2 pt-0 pb-2">
              <div className="homeContent mt-4">

                <div
                  className="card align-items-center text-center" 
                  onClick={()=> {
                    ReactGA.event({
                      category: 'User Home Rewards',
                      action: 'CLK_HOME_REWARD_BTN',
                    });
                    navigate(`/${lang}/awardsummary`) 
                  }}  
                   
                >
                  <div className="card-body">
                    <img
                      src={RewardImage}
                      className="homeImage"
                      alt="homeImage"
                    />
                    <p className="modal-title mt-2">{t("Rewards")}</p>
                  </div>
                </div>

                <div
                  className="card align-items-center text-center"
                  onClick={()=> {
                    ReactGA.event({
                      category: 'User Home Scan Product',
                      action: 'CLK_HOME_SCAN_BTN',
                    });
                    navigate(`/${lang}/scanproduct`) 
                  }}  
                   
                >
                  <div className="card-body">
                    <img
                      src={ScanMoreImg}
                      className="homeImage"
                      alt="homeImage"
                    />
                    <p className="modal-title mt-2">{t("Scanmore")}</p>
                  </div>
                </div>

                {/* <div
                  className="card align-items-center text-center"
                  onClick={()=> {
                    ReactGA.event({
                      category: 'User Home Terms & Cond',
                      action: 'CLK_HOME_TNC_BTN',
                    });
                    navigate(`/${lang}/strongarmdhamaka`) 
                  }}   
                >
                  <div className="card-body">
                    <img
                      src={ConditionImg}
                      className="homeImage"
                      alt="homeImage"
                    />
                    <p className="modal-title mt-2">{t("TermsandConditons")}</p>
                  </div>
                </div> 
                
                <div
                  className="card align-items-center text-center"
                  onClick={()=> {
                    ReactGA.event({
                      category: 'User Home Program Details',
                      action: 'CLK_HOME_PGM_BTN',
                    });
                    navigate(`/${lang}/programDetails`) 
                  }}    
                >
                  <div className="card-body">
                    <img
                      src={ProgramImg}
                      className="homeImage"
                      alt="homeImage"
                    />
                    <p className="modal-title mt-2">{t("programDetails")}</p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
